'use strict';
import Vivus from 'vivus';

/**
 * svg
 */
export const svg = (() => {
    const strokes = [];

    /**
     * init
     */
    const init = () => {

        if ($('.js-svg').length) {
            set();

            $(window).on('load', function () {
                $.when(
                    set()
                ).done(function () {
                    draw();
                })
            });

            $(window).on('scroll', function () {
                setTimeout(() => {
                    draw();
                }, 100);
            });
        }
    };

    const set = () => {
        for (let i = 0; i < $('.js-svg').length; i++) {
            let num = ("0" + (i + 1)).slice(-2);
            let target = 'js-svg-path-' + num;

            if ($('#' + target).length) {
                strokes[i] = new Vivus(target, {
                    duration: 1000, type: 'sync', start: 'manual', forceRender: false, pathTimingFunction: Vivus.EASE_OUT
                });
            }
        }
    };

    const draw = () => {
        $('.js-svg').each((index, element) => {
            const $this = $(element);
            const targetNum = $this.children('svg').attr('id').replace('js-svg-path-', '');
            const num = Number((targetNum - 1));

            if ($this.hasClass('is-inview') && num < $('.js-svg').length) {
                strokes[num].play();
            }
        });
    };

    // public
    return {
        init: init
    };
})();